import { getLocationMapsURL } from '@mi-front/core';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { Box, Link, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const viewOnMapMessage = defineMessage({
  id: 'fleet.devices.card.viewOnMap',
  defaultMessage: 'Ver en el mapa',
});

/**
 * Location label; links to Google Maps when coordinates are available.
 */
export function BalenaDeviceCardLocation({
  location,
  lat,
  lng,
  mb = 1.5,
}: {
  location?: string;
  lat?: string;
  lng?: string;
  mb?: number;
}) {
  const { $t } = useIntl();
  const hasCoords = Boolean(lat && lng);

  if (!location && !hasCoords) {
    return null;
  }

  return (
    <Box sx={{ mb, minWidth: 0 }}>
      {hasCoords ? (
        <Link
          href={getLocationMapsURL(lat!, lng!)}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          variant="caption"
          color="text.secondary"
          noWrap
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            maxWidth: '100%',
          }}
        >
          <PlaceOutlinedIcon sx={{ fontSize: 14, color: 'text.disabled', flexShrink: 0 }} />
          {location || $t(viewOnMapMessage)}
        </Link>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
          <PlaceOutlinedIcon sx={{ fontSize: 14, color: 'text.disabled', flexShrink: 0 }} />
          <Typography variant="caption" color="text.secondary" noWrap>
            {location}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
